export function ThumbsIco(rest) {
  return (
    <svg
      {...rest}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6532_41507)">
        <path
          d="M11.3353 8.66756L8.66864 14.6676C8.13821 14.6676 7.6295 14.4568 7.25443 14.0818C6.87935 13.7067 6.66864 13.198 6.66864 12.6676V10.0009H2.89531C2.70203 10.0031 2.5106 9.96322 2.33426 9.88408C2.15792 9.80494 2.0009 9.6884 1.87407 9.54255C1.74724 9.3967 1.65364 9.22501 1.59975 9.03939C1.54586 8.85377 1.53297 8.65865 1.56197 8.46756L2.48197 2.46756C2.53019 2.14962 2.69168 1.85982 2.9367 1.65155C3.18172 1.44329 3.49375 1.33059 3.81531 1.33423H11.3353M11.3353 8.66756V1.33423M11.3353 8.66756H13.1153C13.4926 8.67423 13.8592 8.54213 14.1456 8.29635C14.4319 8.05056 14.6181 7.70819 14.6686 7.33422V2.66756C14.6181 2.2936 14.4319 1.95123 14.1456 1.70544C13.8592 1.45965 13.4926 1.32755 13.1153 1.33423H11.3353"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6532_41507">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function PlusIco(rest) {
  return (
    <svg
      width="40"
      {...rest}
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0026 8.33398V31.6673M8.33594 20.0007H31.6693"
        stroke="#07D3C4"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ArrowIcon(rest) {
  return (
    <svg
      width="20"
      height="20"
      {...rest}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12.8327L5 7.83268L6.16667 6.66602L10 10.4993L13.8333 6.66602L15 7.83268L10 12.8327Z"
        fill="#F3F3F3"
      />
    </svg>
  );
}
export function DragIco(rest) {
  return (
    <svg
      width="24"
      height="24"
      {...rest}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 15V13H20V15H4ZM4 11V9H20V11H4Z" fill="white" />
    </svg>
  );
}

export function BriefcaseIco(rest) {
  return (
    <svg
      {...rest}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3307 17.5V4.16667C13.3307 3.72464 13.1551 3.30072 12.8426 2.98816C12.53 2.67559 12.1061 2.5 11.6641 2.5H8.33073C7.8887 2.5 7.46478 2.67559 7.15222 2.98816C6.83966 3.30072 6.66406 3.72464 6.66406 4.16667V17.5M3.33073 5.83333H16.6641C17.5845 5.83333 18.3307 6.57953 18.3307 7.5V15.8333C18.3307 16.7538 17.5845 17.5 16.6641 17.5H3.33073C2.41025 17.5 1.66406 16.7538 1.66406 15.8333V7.5C1.66406 6.57953 2.41025 5.83333 3.33073 5.83333Z"
        stroke="#07D3C4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BarIco(rest) {
  return (
    <svg
      {...rest}
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 13.3327V6.66602M9.5 13.3327V2.66602M4.75 13.3327V9.33268"
        stroke="#07D3C4"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function GraduationCapIco(rest) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7199_41974)">
        <path
          d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
          stroke="#07D3C4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 13.5C11.4853 13.5 13.5 11.4853 13.5 9C13.5 6.51472 11.4853 4.5 9 4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 11.4853 6.51472 13.5 9 13.5Z"
          stroke="#07D3C4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z"
          stroke="#07D3C4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7199_41974">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function BookOpenIco(rest) {
  return (
    <svg
    {...rest}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7199_42043)">
        <path
          d="M8.0026 1.33398V4.00065M8.0026 12.0007V14.6673M3.28927 3.28732L5.17594 5.17398M10.8293 10.8273L12.7159 12.714M1.33594 8.00065H4.0026M12.0026 8.00065H14.6693M3.28927 12.714L5.17594 10.8273M10.8293 5.17398L12.7159 3.28732"
          stroke="#07D3C4"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7199_42043">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function User(rest) {
  return <svg {...rest} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9974 10.9993C9.98906 10.9993 9.12587 10.6403 8.40781 9.92227C7.68976 9.20421 7.33073 8.34102 7.33073 7.33268C7.33073 6.32435 7.68976 5.46115 8.40781 4.7431C9.12587 4.02504 9.98906 3.66602 10.9974 3.66602C12.0057 3.66602 12.8689 4.02504 13.587 4.7431C14.305 5.46115 14.6641 6.32435 14.6641 7.33268C14.6641 8.34102 14.305 9.20421 13.587 9.92227C12.8689 10.6403 12.0057 10.9993 10.9974 10.9993ZM3.66406 18.3327V15.766C3.66406 15.2466 3.79774 14.7691 4.0651 14.3337C4.33247 13.8983 4.68767 13.566 5.13073 13.3368C6.07795 12.8632 7.04045 12.508 8.01823 12.2712C8.99601 12.0344 9.98906 11.916 10.9974 11.916C12.0057 11.916 12.9988 12.0344 13.9766 12.2712C14.9543 12.508 15.9168 12.8632 16.8641 13.3368C17.3071 13.566 17.6623 13.8983 17.9297 14.3337C18.197 14.7691 18.3307 15.2466 18.3307 15.766V18.3327H3.66406ZM5.4974 16.4993H16.4974V15.766C16.4974 15.598 16.4554 15.4452 16.3714 15.3077C16.2873 15.1702 16.1766 15.0632 16.0391 14.9868C15.2141 14.5743 14.3814 14.265 13.5411 14.0587C12.7009 13.8525 11.853 13.7493 10.9974 13.7493C10.1418 13.7493 9.29392 13.8525 8.45365 14.0587C7.61337 14.265 6.78073 14.5743 5.95573 14.9868C5.81823 15.0632 5.70747 15.1702 5.62344 15.3077C5.53941 15.4452 5.4974 15.598 5.4974 15.766V16.4993ZM10.9974 9.16602C11.5016 9.16602 11.9332 8.9865 12.2922 8.62747C12.6512 8.26845 12.8307 7.83685 12.8307 7.33268C12.8307 6.82852 12.6512 6.39692 12.2922 6.03789C11.9332 5.67886 11.5016 5.49935 10.9974 5.49935C10.4932 5.49935 10.0616 5.67886 9.7026 6.03789C9.34358 6.39692 9.16406 6.82852 9.16406 7.33268C9.16406 7.83685 9.34358 8.26845 9.7026 8.62747C10.0616 8.9865 10.4932 9.16602 10.9974 9.16602Z" fill="#07D3C4"/>
</svg>
}